import { useEffect, useState } from 'react';
import magic from './magic';
import './BatteryPanel.css';

function BatteryPanel ({ visible = true }) {
    const [volts, setVolts] = useState(0);
    const [current, setCurrent] = useState(0);
    const [temperature, setTemperature] = useState(0);
    const [soc, setSoc] = useState(0);
    const [soh, setSoh] = useState(0);
    const [power, setPower] = useState(0);
    const [status, setStatus] = useState('Idle');
    const [capacity, setCapacity] = useState(0);

    useEffect(() => {
        const onBattery = (battery) => {
            setVolts(battery.voltage);
            setCurrent(battery.current);
            setTemperature(battery.temp);
            setSoc(battery.soc);
            setSoh(battery.soh);
            setPower(battery.power);
            setStatus(battery.status);
            setCapacity(battery.capacity);
        };
        magic.bleEventDispatcher.on('battery', onBattery);
        return () => {
            magic.bleEventDispatcher.removeListener('battery', onBattery);
        }
    }, []);

    const getSocColor = () => {
        if (soc >= 80) return '#3a6';
        if (soc >= 40) return '#fa0';
        return '#c44';
    };

    const getPowerColor = () => {
        if (power > 0) return '#3a6'; // charging
        if (power < -500) return '#fa0'; // high discharge
        if (power < 0) return '#888'; // light discharge
        return '#666'; // idle
    };

    if (!visible) return null;

    return (
        <div className="battery-panel">
            {capacity === 0 ? (
                <div className="battery-no-device">
                    <div className="battery-no-device-icon">🔋</div>
                    <div className="battery-no-device-text">No battery detected</div>
                </div>
            ) : (
                <>
                    {/* Main Battery Status */}
                    <div className="battery-status-card">
                        <div className="battery-soc-ring" style={{ '--soc-color': getSocColor(), '--soc-percent': soc }}>
                            <div className="battery-soc-inner">
                                <span className="battery-soc-value">{soc}</span>
                                <span className="battery-soc-unit">%</span>
                            </div>
                        </div>
                        <div className="battery-status-info">
                            <div className="battery-status-text">{status}</div>
                            <div className="battery-voltage">{volts.toFixed(1)}V</div>
                        </div>
                    </div>

                    {/* Power Flow */}
                    <div className="battery-card">
                        <div className="battery-power-display">
                            <span className="battery-power-value" style={{ color: getPowerColor() }}>
                                {power > 0 ? '+' : ''}{power.toFixed(0)}
                            </span>
                            <span className="battery-power-unit">W</span>
                        </div>
                        <div className="battery-current">
                            {current > 0 ? '⚡ Charging' : current < 0 ? '📤 Discharging' : 'Idle'} @ {Math.abs(current).toFixed(1)}A
                        </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="battery-stats-grid">
                        <div className="battery-stat-item">
                            <span className="battery-stat-label">Temperature</span>
                            <span className="battery-stat-value">{temperature}°C</span>
                        </div>
                        <div className="battery-stat-item">
                            <span className="battery-stat-label">Health</span>
                            <span className="battery-stat-value">{soh}%</span>
                        </div>
                        <div className="battery-stat-item">
                            <span className="battery-stat-label">Capacity</span>
                            <span className="battery-stat-value">{capacity}Ah</span>
                        </div>
                        <div className="battery-stat-item">
                            <span className="battery-stat-label">Voltage</span>
                            <span className="battery-stat-value">{volts.toFixed(2)}V</span>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default BatteryPanel;
